export default __webpack_public_path__ + "static/media/discordbot.d84c4e76.png";